import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFeathubComponent } from './simple-icons-feathub.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFeathubComponent ],
    exports:      [ SimpleIconsFeathubComponent ],
    bootstrap:    []
})
export class SimpleIconsFeathubModule {}
